import { createFileRoute } from "@tanstack/react-router";

import { coachContentHubsQueryOptions } from "src/components/contentHubQueries";
import { ContentHubListPage } from "src/pages/ContentHubListPage";

export const Route = createFileRoute("/_auth/_coach/content-hub/")({
  component: ContentHubListPage,
  ssr: true,
  async loader({ context }) {
    return context.queryClient.query({
      ...coachContentHubsQueryOptions(),
      staleTime: "static",
    });
  },
});
